// Gets a field of a contact model
export default function (attribute, model) {
  return model.getTranslatedCommonField(attribute);
}
